(function () {
  function installKlaviyoProxy() {
    if (window.klaviyo) {
      return;
    }

    window._klOnsite = window._klOnsite || [];

    try {
      window.klaviyo = new Proxy({}, {
        get: function (_, method) {
          if (method === "push") {
            return function () {
              window._klOnsite.push.apply(window._klOnsite, arguments);
            };
          }

          return function () {
            var args = Array.prototype.slice.call(arguments);
            var callback = typeof args[args.length - 1] === "function" ? args.pop() : null;

            return new Promise(function (resolve) {
              window._klOnsite.push([method].concat(args, [function (result) {
                if (callback) {
                  callback(result);
                }

                resolve(result);
              }]));
            });
          };
        }
      });
    } catch (error) {
      window.klaviyo = [];
      window.klaviyo.push = function () {
        window._klOnsite.push.apply(window._klOnsite, arguments);
      };
    }
  }

  function installKlaviyoOnsiteLoader() {
    var config = window.VPAKlaviyo || {};
    var loadRequested = false;
    var privacyReady = false;
    var loaded = false;
    var observer;

    if (!config.publicApiKey || window.__vpaKlaviyoOnsiteLoaded || document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) {
      return;
    }

    function marketingAllowed() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;

      if (!privacy || typeof privacy.marketingAllowed !== "function") {
        return privacyReady;
      }

      return privacy.marketingAllowed();
    }

    function load() {
      var script;

      if (loaded || !loadRequested || !marketingAllowed()) {
        return;
      }

      loaded = true;
      window.__vpaKlaviyoOnsiteLoaded = true;
      observer && observer.disconnect();
      script = document.createElement("script");
      script.async = true;
      script.src = "https://static.klaviyo.com/onsite/js/" + encodeURIComponent(config.publicApiKey) + "/klaviyo.js";
      document.head.appendChild(script);
    }

    function requestLoad() {
      loadRequested = true;
      load();
    }

    function setPrivacyReady() {
      privacyReady = true;
      load();
    }

    document.addEventListener("visitorConsentCollected", function (event) {
      if (event.detail && event.detail.marketingAllowed === false) {
        return;
      }

      setPrivacyReady();
    });

    ["pointerdown", "keydown", "touchstart"].forEach(function (eventName) {
      document.addEventListener(eventName, requestLoad, { once: true, passive: true });
    });

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          requestLoad();
        }
      }, { rootMargin: "600px 0px" });

      document.querySelectorAll(".vpa-global-klaviyo-form, [class*='klaviyo-form-']").forEach(function (form) {
        observer.observe(form);
      });
    }

    function scheduleIdleLoad() {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(requestLoad, { timeout: 6000 });
      } else {
        window.setTimeout(requestLoad, 3500);
      }
    }

    if (document.readyState === "complete") {
      scheduleIdleLoad();
    } else {
      window.addEventListener("load", scheduleIdleLoad, { once: true });
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      setPrivacyReady();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
        setPrivacyReady();
      });
    } else {
      setPrivacyReady();
    }
  }

  installKlaviyoProxy();
  installKlaviyoOnsiteLoader();

  if (window.VPAKlaviyo && window.VPAKlaviyo.customerProfile) {
    window.klaviyo.identify(window.VPAKlaviyo.customerProfile);
  }

  if (window.VPAKlaviyo && window.VPAKlaviyo.viewedItem) {
    window.klaviyo.trackViewedItem(window.VPAKlaviyo.viewedItem);
  }

  function getFieldValue(form, selector) {
    var field = form.querySelector(selector);

    return field ? field.value.trim() : "";
  }

  function isNewsletterForm(form) {
    var tagsField = form.querySelector('input[name="contact[tags]"]');

    return Boolean(tagsField && tagsField.value.toLowerCase().indexOf("newsletter") !== -1);
  }

  function getNewsletterProfile(form) {
    var profile = {
      email: getFieldValue(form, '[name="contact[email]"]')
    };
    var properties = {};
    var firstName = getFieldValue(form, '[name="contact[first_name]"]');
    var lastName = getFieldValue(form, '[name="contact[last_name]"]');
    var phoneNumber = getFieldValue(form, '[name="contact[phone]"]');
    var gender = getFieldValue(form, '[name="contact[note][gender]"]');
    var birthdate = getFieldValue(form, '[name="contact[note][birthdate]"]');

    if (firstName) {
      profile.first_name = firstName;
    }

    if (lastName) {
      profile.last_name = lastName;
    }

    if (phoneNumber) {
      profile.phone_number = phoneNumber;
    }

    if (gender) {
      properties.Gender = gender;
    }

    if (birthdate) {
      properties.Birthdate = birthdate;
    }

    if (Object.keys(properties).length) {
      profile.properties = properties;
    }

    return profile;
  }

  function getIdentifyProfile(profile) {
    var identifyProfile = Object.assign({}, profile, profile.properties || {});

    delete identifyProfile.properties;

    return identifyProfile;
  }

  function getSubscriptionPayload(profile, listId) {
    var attributes = {
      profile: {
        data: {
          type: "profile",
          attributes: profile
        }
      },
      custom_source: "Shopify newsletter form"
    };
    var subscriptions = {
      email: {
        marketing: {
          consent: "SUBSCRIBED"
        }
      }
    };
    var payload = {
      data: {
        type: "subscription",
        attributes: attributes,
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId
            }
          }
        }
      }
    };

    attributes.profile.data.subscriptions = subscriptions;

    return payload;
  }

  function subscribeProfile(profile) {
    var config = window.VPAKlaviyo || {};

    if (!config.publicApiKey || !config.listId) {
      return Promise.resolve(false);
    }

    return fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(config.publicApiKey), {
      method: "POST",
      keepalive: true,
      headers: {
        "content-type": "application/json",
        "revision": "2026-04-15"
      },
      body: JSON.stringify(getSubscriptionPayload(profile, config.listId))
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Klaviyo subscription failed with status " + response.status);
      }

      return true;
    }).catch(function () {
      return false;
    });
  }

  function trackLegacyArticleView() {
    var config = window.VPAKlaviyo || {};
    var articleView = config.articleView;

    if (!articleView || !articleView.customerId || !articleView.email || !articleView.url) {
      return;
    }

    var endpoint = new URL("https://customers.vpa.com.au/api/klaviyo/properties/view");

    endpoint.searchParams.set("shid", String(articleView.customerId));
    endpoint.searchParams.set("email", articleView.email);
    endpoint.searchParams.set("view", articleView.viewType === "recipe" ? "recipe" : "article");
    endpoint.searchParams.set("url", articleView.url);

    fetch(endpoint.toString(), {
      method: "GET",
      credentials: "omit",
      keepalive: true
    }).catch(function () {});
  }

  function amountFromCents(value) {
    return typeof value === "number" ? value / 100 : 0;
  }

  function absoluteStoreUrl(path) {
    if (!path) {
      return "";
    }

    try {
      return new URL(path, window.location.origin).toString();
    } catch (error) {
      return String(path);
    }
  }

  function getAddedItems(responseData) {
    if (responseData && Array.isArray(responseData.items)) {
      return responseData.items;
    }

    if (responseData && (responseData.id || responseData.variant_id)) {
      return [responseData];
    }

    return [];
  }

  function getAddedItemImage(item) {
    if (!item) {
      return "";
    }

    if (typeof item.image === "string") {
      return absoluteStoreUrl(item.image);
    }

    if (item.featured_image && item.featured_image.url) {
      return absoluteStoreUrl(item.featured_image.url);
    }

    return "";
  }

  function mapAddedItem(item) {
    return {
      ProductName: item.product_title || item.title || "",
      ProductID: item.product_id ? String(item.product_id) : "",
      VariantID: item.variant_id || item.id ? String(item.variant_id || item.id) : "",
      SKU: item.sku || "",
      Quantity: item.quantity || 1,
      ItemPrice: amountFromCents(typeof item.final_price === "number" ? item.final_price : item.price),
      RowTotal: amountFromCents(item.final_line_price),
      ProductURL: absoluteStoreUrl(item.url),
      ImageURL: getAddedItemImage(item)
    };
  }

  function trackAddedToCart(responseData, nativeFetch) {
    var addedItems = getAddedItems(responseData);
    var routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";

    nativeFetch.call(window, routesRoot + "cart.js", { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to read cart");
        }

        return response.json();
      })
      .then(function (cart) {
        if (!window.klaviyo) {
          return;
        }

        var mappedAddedItems = addedItems.map(mapAddedItem);
        var firstAddedItem = mappedAddedItems[0] || {};
        var eventProperties = {
          $value: amountFromCents(cart.total_price),
          total_price: amountFromCents(cart.total_price),
          total_discount: amountFromCents(cart.total_discount),
          original_total_price: amountFromCents(cart.original_total_price),
          items: cart.items || [],
          ItemNames: (cart.items || []).map(function (item) {
            return item.product_title || item.title || "";
          }),
          CheckoutURL: absoluteStoreUrl(routesRoot + "checkout"),
          AddedItems: mappedAddedItems,
          AddedItemProductName: firstAddedItem.ProductName || "",
          AddedItemProductID: firstAddedItem.ProductID || "",
          AddedItemVariantID: firstAddedItem.VariantID || "",
          AddedItemSKU: firstAddedItem.SKU || "",
          AddedItemQuantity: firstAddedItem.Quantity || 1,
          AddedItemPrice: firstAddedItem.ItemPrice || 0,
          AddedItemURL: firstAddedItem.ProductURL || "",
          AddedItemImageURL: firstAddedItem.ImageURL || ""
        };

        window.klaviyo.track("Added to Cart", eventProperties);
      })
      .catch(function () {});
  }

  function isCartAddUrl(url) {
    if (!url) {
      return false;
    }

    try {
      return new URL(url, window.location.origin).pathname.replace(/\/+$/, "").endsWith("/cart/add.js");
    } catch (error) {
      return String(url).indexOf("/cart/add.js") !== -1;
    }
  }

  function installAddedToCartTracking() {
    var config = window.VPAKlaviyo || {};

    if (!config.manualAddedToCartTracking || window.__vpaKlaviyoFetchWrapped || typeof window.fetch !== "function") {
      return;
    }

    var nativeFetch = window.fetch;

    window.__vpaKlaviyoFetchWrapped = true;
    window.fetch = function () {
      var request = arguments[0];
      var requestUrl = typeof request === "string" ? request : request && request.url;
      var responsePromise = nativeFetch.apply(this, arguments);

      responsePromise.then(function (response) {
        if (!response.ok || (!isCartAddUrl(requestUrl) && !isCartAddUrl(response.url))) {
          return;
        }

        response.clone().json().then(function (responseData) {
          trackAddedToCart(responseData, nativeFetch);
        }).catch(function () {});
      }).catch(function () {});

      return responsePromise;
    };
  }

  installAddedToCartTracking();
  trackLegacyArticleView();

  document.addEventListener("submit", function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement) || !window.klaviyo || !isNewsletterForm(form)) {
      return;
    }

    var profile = getNewsletterProfile(form);

    if (!profile.email) {
      return;
    }

    var eventProperties = {
      Source: window.VPAKlaviyo && window.VPAKlaviyo.source ? window.VPAKlaviyo.source : "VPA Australia",
      FormId: form.id || "",
      PageUrl: window.location.href
    };

    if (window.VPAKlaviyo && window.VPAKlaviyo.listId) {
      eventProperties.ListId = window.VPAKlaviyo.listId;
    }

    window.klaviyo.identify(getIdentifyProfile(profile));
    window.klaviyo.track("Newsletter Signup Submitted", eventProperties);
    subscribeProfile(profile);
  }, true);
})();
